import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const LicenseTypeCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.LICENSE_TYPES, "uid");